import React from "react";
import "../styles/App.css";
import SteamStatus from "../components/SteamStatus";
import SpotifyNowPlaying from "../components/SpotifyNowPlaying";

const Home = () => {
  return (
    <div>
      <h1>Welcome</h1>
      <div className="status-row">
        <SteamStatus />
        <SpotifyNowPlaying />
      </div>
      <p>I'm most likely playing something on Steam and/or listening to music. If I am, you can see the info above.</p>
      <p>
        This is a work in progress. It's also a hobby so don't expect much
        change.
      </p>
      <p>
        
      </p>
    </div>
  );
};

export default Home;
